import React, { useCallback, useContext, useEffect, useMemo, useState } from "react";

const DashboardShareReadinessContext = React.createContext(null);

export function DashboardShareReadinessProvider({ activeTabKey, children }) {
  const [readyByTab, setReadyByTab] = useState({});

  const setTabShareReady = useCallback((tabKey, ready) => {
    const key = String(tabKey || "").trim();
    if (!key) return;
    setReadyByTab((prev) => {
      const nextReady = Boolean(ready);
      if (Boolean(prev[key]) === nextReady) return prev;
      return { ...prev, [key]: nextReady };
    });
  }, []);

  const isShareReady = Boolean(activeTabKey && readyByTab[activeTabKey]);

  const value = useMemo(
    () => ({ activeTabKey, isShareReady, setTabShareReady }),
    [activeTabKey, isShareReady, setTabShareReady]
  );

  return (
    <DashboardShareReadinessContext.Provider value={value}>
      {children}
    </DashboardShareReadinessContext.Provider>
  );
}

export function useDashboardShareReadiness() {
  const ctx = useContext(DashboardShareReadinessContext);
  return ctx?.isShareReady ?? false;
}

export function useReportDashboardShareReady(ready) {
  const ctx = useContext(DashboardShareReadinessContext);
  const tabKey = ctx?.activeTabKey;
  const setTabShareReady = ctx?.setTabShareReady;

  useEffect(() => {
    if (!tabKey || !setTabShareReady) return undefined;
    setTabShareReady(tabKey, ready);
    return () => setTabShareReady(tabKey, false);
  }, [tabKey, ready, setTabShareReady]);
}
